import React from "react";
import ContactForm from "../../components/Contact/ContactForm";
import Nav from "../../components/Nav/Nav";
import { Helmet } from "react-helmet-async";

const siteUrl = "https://www.dore-avocat.fr";

function PageContact(props) {
  return (
    <div>
      <Helmet>
        <title>Contact - Cabinet Maître Camille Doré, avocate à Lille</title>
        <meta name="description" content="Contactez le cabinet de Maître Camille Doré, avocate à Lille spécialisée en droit des étrangers. Formulaire de contact disponible pour toute question juridique." />
        <link rel="canonical" href={`${siteUrl}/contact`} />
        <meta property="og:title" content="Contact - Cabinet Maître Camille Doré, avocate à Lille" />
        <meta property="og:description" content="Contactez le cabinet de Maître Camille Doré, avocate à Lille spécialisée en droit des étrangers." />
        <meta property="og:url" content={`${siteUrl}/contact`} />
      </Helmet>
      <Nav />
      <ContactForm />{" "}
    </div>
  );
}

export default PageContact;
